
const Checkbox = ({ label, value, onChange }) => {
    return (
    <div className="hs-form-booleancheckbox mt-5">
      <label>
        <input type="checkbox" checked={value} onChange={onChange} />
        <span>{label}</span>
      </label>
    </div>
    );
};

export default Checkbox;